import React, { useState } from 'react';
import { supabase } from '../lib/supabase';
import { Button } from '../components/ui/button';
import { useNavigate } from "react-router-dom";


const LeaveReview = () => {
  const [form, setForm] = useState({
    name: '',
    trek_name: '',
    place: '',
    review: '',
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();


  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const { error } = await supabase
      .from('testimonials')
      .insert([form]);

    if (!error) {
      setSuccess(true);
      setForm({ name: '', trek_name: '', place: '', review: '' });
    }

    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="max-w-lg w-full bg-white shadow-xl rounded-3xl p-8">
        <h1 className="text-3xl font-bold mb-6 text-center">
          Leave a Review
        </h1>

        {success && (
          <p className="text-emerald-600 text-center mb-4">
            Thank you for your review ❤️
          </p>
        )}
        <Button
             onClick={() => navigate("/")}
             className="mt-6 bg-emerald-600 hover:bg-emerald-700"
       >
             Back to Home
            </Button>


        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            name="name"
            placeholder="Your name"
            value={form.name}
            onChange={handleChange}
            required
            className="w-full border rounded-xl px-4 py-3"
          />

          <input
            name="trek_name"
            placeholder="Trek name"
            value={form.trek_name}
            onChange={handleChange}
            required
            className="w-full border rounded-xl px-4 py-3"
          />

          <input
            name="place"
            placeholder="Place of stay"
            value={form.place}
            onChange={handleChange}
            required
            className="w-full border rounded-xl px-4 py-3"
          />

          <textarea
            name="review"
            placeholder="Your experience"
            value={form.review}
            onChange={handleChange}W
            required
            rows={5}
            className="w-full border rounded-xl px-4 py-3"
          />

          <Button
            type="submit"
            disabled={loading}
            className="w-full bg-emerald-600 hover:bg-emerald-700"
          >
            {loading ? 'Submitting...' : 'Submit Review'}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default LeaveReview;
